if (!customElements.get("sticky-buy-bar")) {
  customElements.define(
    "sticky-buy-bar",
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.anchor = document.querySelector("[data-sticky-buy-anchor]");
        if (!this.anchor) return;

        this.sectionId = this.dataset.sectionId;
        this.priceNode = this.querySelector("[data-sticky-price]");
        this.imageNode = this.querySelector("[data-sticky-image]");
        this.scrollButton = this.querySelector("[data-sticky-scroll-to-cart]");
        this.mainPrice = document.getElementById(`price-${this.sectionId}`);
        this.variantOptions = document.querySelector(
          `variant-options[data-section="${this.sectionId}"]`,
        );

        this.showClass = "wt-product__sticky-buy--show";
        this.bodyClass = "sticky-buy-active";
        this.syncFromMain = this.syncFromMain.bind(this);
        this.onScrollClick = this.onScrollClick.bind(this);

        this.setVisible(false);

        this.observer = new IntersectionObserver(
          ([entry]) => {
            const scrolledPastAnchor =
              !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.setVisible(scrolledPastAnchor);
          },
          { threshold: 0 },
        );
        this.observer.observe(this.anchor);

        this.scrollButton?.addEventListener("click", this.onScrollClick);
        document.addEventListener("variantChangeEnd", this.syncFromMain);
        document.addEventListener("change", (event) => {
          if (event.target.matches('.wt-product__option input[type="radio"]')) {
            this.syncFromMain();
          }
        });

        if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            () => this.syncFromMain(),
          );
        }

        this.syncFromMain();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.variantChangeUnsubscriber?.();
        document.removeEventListener("variantChangeEnd", this.syncFromMain);
        document.body.classList.remove(this.bodyClass);
      }

      setVisible(show) {
        this.classList.toggle(this.showClass, show);
        this.toggleAttribute("hidden", !show);
        document.body.classList.toggle(this.bodyClass, show);
        document.documentElement.style.setProperty(
          "--sticky-buy-bar-height",
          show ? `${this.offsetHeight}px` : "0px",
        );
      }

      onScrollClick(event) {
        event.preventDefault();
        this.anchor?.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      getDisplayedPrice() {
        if (!this.mainPrice) {
          return this.priceNode?.textContent?.trim() || "";
        }

        const sale = this.mainPrice.querySelector(
          ".price__sale .price-item--last",
        );
        const regular = this.mainPrice.querySelector(".price-item--regular");
        const priceEl = sale || regular;

        return priceEl?.textContent?.trim() || this.priceNode?.textContent?.trim() || "";
      }

      getVariantImageSrc() {
        const fromVariant = this.variantOptions?.dataset.featuredImage;
        if (fromVariant) return fromVariant;

        const activeImg = document.querySelector(
          ".wt-product__gallery .swiper-slide-active .wt-product__img, gallery-section .swiper-slide-active .wt-product__img",
        );

        return activeImg?.currentSrc || activeImg?.src || "";
      }

      syncImage() {
        if (!this.imageNode) return;

        const src = this.getVariantImageSrc();
        if (!src || this.imageNode.src === src) return;

        this.imageNode.src = src;
      }

      syncFromMain() {
        const priceText = this.getDisplayedPrice();

        if (this.priceNode && priceText) {
          this.priceNode.textContent = priceText;
        }

        this.syncImage();
      }
    },
  );
}
